export default __webpack_public_path__ + "static/media/corona.d4721523.jpg";